module.exports = __webpack_public_path__ + "img/MT.e93d6bd1.svg";